const findBestSellers = products => (
    products.filter(product => product.amountSold > 100).sort((p1,p2)=>p2.amountSold-p1.amountSold)
 );
 export default findBestSellers;